module.exports = __webpack_public_path__ + "img/calendar_dark_grey_icon.dbe4c91c.svg";